import React from "react";

const Warning = ({ children }) => (
  <p className="text-red text-sm m-2">⚠ {children}</p>
);

export default Warning;
